import React from 'react';
import Lightbox from 'src/components/lightbox/Lightbox';
import { getFileType, getFileUrl } from 'src/utils/fileUploadUtils';

interface IFullScreenViewerProps {
  isOpen: boolean;
  index: number;
  files: Array<File | string>;
  accept: Record<string, any>;
  onClose: () => void;
}

const FullScreenViewer: React.FC<IFullScreenViewerProps> = ({
  isOpen,
  index,
  files,
  accept,
  onClose,
}) => {
  return (
    <Lightbox
      open={isOpen}
      close={onClose}
      index={index}
      disabledVideo={false}
      carousel={{
        finite: true,
        preload: 0,
        padding: 0,
        spacing: 0,
      }}
      animation={{
        swipe: 240,
        fade: 0,
      }}
      controller={{
        closeOnBackdropClick: true,
        touchAction: 'none',
      }}
      styles={{
        container: { overflow: 'hidden' },
      }}
      slides={files.map((file) => {
        const fileType = getFileType(file, accept);
        const fileURL = getFileUrl(file);

        if (fileType.type === 'video') {
          return {
            type: 'video',
            sources: [
              {
                src: fileURL,
                type: 'video/mp4',
              },
            ],
            autoPlay: false,
            controls: false,
            playsInline: true,
            preload: 'metadata', // 메타데이터만 미리 로드
            controlsList: 'nodownload', // 다운로드 버튼 숨김
          };
        }
        return { src: fileURL };
      })}
    />
  );
};

export default FullScreenViewer;
